import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, AbstractControl, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ElementService } from '../../../core/services/element.service';
import { OptionService } from '../../../core/services/option.service';
import { Element } from '../../../core/models/element.model';
import { Option } from '../../../core/models/option.model';

@Component({
  selector: 'app-element-option-create',
  templateUrl: './element-option-create.component.html',
  styleUrls: ['./element-option-create.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatExpansionModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatCheckboxModule,
  ],
})
export class ElementOptionCreateComponent implements OnInit {
  @Input() formGroup!: FormGroup;
  @Output() remove = new EventEmitter<void>();
  elements: Element[] = [];
  options: Option[] = [];

  constructor(
    private elementService: ElementService,
    private optionService: OptionService,
    private fb: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.loadElements();
    this.loadOptions();
    this.initializeFormGroup();
  }

  loadElements(): void {
    this.elementService.getElements().subscribe((data: Element[]) => {
      this.elements = data;
    });
  }

  loadOptions(): void {
    this.optionService.getOptions().subscribe((data: Option[]) => {
      this.options = data;
      // console.log('Opciones cargadas:', this.options);
    });
  }

  initializeFormGroup(): void {
    if (!this.formGroup.contains('labelName')) {
      this.formGroup.addControl('labelName', this.fb.control('', Validators.required));
    }
    if (!this.formGroup.contains('elementType')) {
      this.formGroup.addControl('elementType', this.fb.control('', Validators.required));
    }
    if (!this.formGroup.contains('options')) {
      this.formGroup.addControl('options', this.fb.array([]));
    }
  }

  isComboBoxSelected(): boolean {
    return (
      this.formGroup.get('elementType')?.value === 4 ||
      this.formGroup.get('elementType')?.value === 16
    );
  }

  addOptionControls(): void {
    if (!this.formGroup.contains('options')) {
      this.formGroup.addControl('options', this.fb.array([]));
    }
  }

  addOption(): void {
    const optionsArray = this.formGroup.get('options') as FormArray;
    optionsArray.push(
      this.fb.group({
        id: [''],
        subOptions: this.fb.array([]),
      }),
    );
  }

  removeOption(index: number): void {
    const optionsArray = this.formGroup.get('options') as FormArray;
    optionsArray.removeAt(index);
  }

  get optionsFormArray(): FormArray {
    return this.formGroup.get('options') as FormArray;
  }

  getOptionFormGroup(control: AbstractControl): FormGroup {
    return control as FormGroup;
  }

  onOptionChange(optionId: number, isChecked: boolean): void {
    if (!this.formGroup.contains('options')) {
      this.formGroup.addControl('options', this.fb.array([]));
    }
    const optionsArray = this.formGroup.get('options') as FormArray;
    if (isChecked) {
      optionsArray.push(
        this.fb.group({
          id: [optionId],
          subOptions: this.fb.array([]),
        }),
      );
    } else {
      const index = optionsArray.controls.findIndex(x => x.value.id === optionId);
      if (index >= 0) {
        optionsArray.removeAt(index);
      }
    }
  }

  isOptionChecked(optionId: number): boolean {
    const optionsArray = this.formGroup.get('options')?.value || [];
    return optionsArray.some((option: any) => option.id === optionId);
  }

  getOptionName(optionId: number): string {
    const option = this.options.find(x => x.id === optionId);
    return option ? option.name : '';
  }

  getSubOptionsFormArray(optionIndex: number): FormArray {
    const optionGroup = this.optionsFormArray.at(optionIndex) as FormGroup;
    return optionGroup.get('subOptions') as FormArray;
  }

  removeSubOption(optionIndex: number, subOptionIndex: number): void {
    const subOptionsArray = this.getSubOptionsFormArray(optionIndex);
    subOptionsArray.removeAt(subOptionIndex);
  }

  removeElement() {
    this.remove.emit();
  }
}
